module.exports = __webpack_public_path__ + "23297bbf86ab99ffe4bdc459ccd28d9d.jpg";